<template>
  <div id="footer" class="footer-two bg-gray pt50">
    <div class="container-fluid bb-solid-1"></div>
    <!-- container-fluid end -->
    <div class="container-fluid pt20">
      <div class="container-fluid">
        <div class="row">
          <!-- copyright start -->
          <div class="col-md-6 col-sm-6 col-xs-6 pull-left">
            <p>Copyright &copy;2018 <router-link :to="{ path: '/contact-us' }">HaitiPay SA</router-link>. All rights reserved.</p>
          </div>
          <!-- copyright end -->
          <!-- footer bottom start -->
          <div class="col-md-6 col-sm-6 col-xs-6 pull-right">
            <p class="text-right">
              <router-link :to="{ path: '/privacy-policy' }"
                class="mr20">Privacy Policy
              </router-link>
              <router-link :to="{ path: '/tos' }" class="mr20">Term of Use</router-link>
              <router-link :to="{ path: '/coockies-policy' }" class="mr50">Coockies Policy</router-link>
            </p>
          </div>
          <!-- footer bottom end -->
        </div>
        <!-- row end -->
      </div>
      <!-- container end -->
    </div>
    <!-- container-fluid end -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      about: `The HaitiPay Platform is a high capacity transaction processing, switching, electronic money and stored value account management system that can be integrated with a broad range of external systems including banks, ATMs, point of sale terminals, mobile phones, web portals, point of sale systems, prepaid and post-paid billing systems, and telecommunications infrastructure`
    }
  }
}
</script>

<style scoped>
a {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterSection.vue